import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { focusOutline } from '@hivebrite/design-system/Theme';

import IconDownload from 'hb-react/shared/icons/Download';

const NoPreviewDownload = ({ url, downloadable }) => {
  if (downloadable) {
    return (
      <StyledWrapper>
        <StyledText>
          {s__('Portfolio|There is no available preview for this type of file')}
        </StyledText>
        <StyledText mb={8}>
          {s__('Portfolio|Please download the file to view it')}
        </StyledText>
        <StyledAction href={url} data-testid="anchor-action">
          <IconDownload height={80} width={80} />
        </StyledAction>
      </StyledWrapper>
    );
  }

  return (
    <StyledWrapper>
      <StyledText>
        {s__('Portfolio|There is no available preview for this type of file')}
      </StyledText>
      <StyledText mb={8}>
        {s__('Portfolio|To view it,  please contact your admin')}
      </StyledText>
    </StyledWrapper>
  );
};

NoPreviewDownload.propTypes = {
  url: PropTypes.string.isRequired,
};

export default NoPreviewDownload;

const StyledWrapper = styled(Box).attrs({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
  height: { _: '200px', m: '290px', l: '230px', xl: '395px' },
  alignItems: 'center',
  p: 2,
})`
  border: 1px solid ${({ theme }) => theme.colors.horizon};
`;

const StyledAction = styled.a`
  ${focusOutline};
  color: ${(props) => props.theme.colors.primary};

  cursor: pointer;
  user-select: none;

  &:hover,
  &:focus {
    color: ${(props) => props.theme.colors.primaryDark};
  }
`;

const StyledText = styled(Box).attrs({
  display: 'block',
  font: 'body-asphalt-italic',
  textAlign: 'center',
})``;
